import { Component, effect, inject } from '@angular/core';
import { PrinterFormService } from '../../../services/printer-form.service';
import { PrintersFormGroups } from '../../../models/settings-printers.model';
import { CommonModule } from '@angular/common';
import { CardComponent } from 'src/app/shared/components/master-detail-layout/card/card.component';
import { ActionBtnComponent } from 'src/app/shared/components/master-detail-layout/action-btn/action-btn.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { Printers } from 'tilby-models';
import { PrintersModuleService } from '../../../services/printers-module.service';

@Component({
  selector: 'app-printer-stub',
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    ActionBtnComponent,
    MatFormFieldModule, ReactiveFormsModule,
    MatInputModule, MatSlideToggleModule,
    MatCheckboxModule,
    TranslateModule
  ],
  templateUrl: './printer-stub.component.html',
  styleUrl: './printer-stub.component.scss'
})
export class PrinterStubComponent {
  
  protected readonly printerFormService = inject(PrinterFormService);  
  private readonly printerModuleService = inject(PrintersModuleService);
  
  protected printerGroupForm!: PrintersFormGroups;
  protected printer: Printers | null = null;

  protected linearLabelClass = "tw-font-medium tw-text-[var(--sys-secondary-text)]";
  protected linearValueClass = "tw-font-medium tw-text-[var(--sys-text)]";
  protected priceLabelClass = "tw-text-[12px] tw-font-bold tw-tracking-wider tw-text-[var(--sys-secondary-text)] tw-mb-1";
  protected priceValueClass = "tw-text-sm tw-font-medium tw-text-[var(--sys-text)]";
  protected subTitleClass = "tw-text-sm tw-font-bold tw-text-[var(--sys-secondary-text)] tw-mb-1";

  constructor() {
    effect(() => {
      if(this.printerFormService.printerFormReady()) {
        this.printerGroupForm = this.printerFormService.form;
      }
    })
    effect(() => {
      this.printer = this.printerModuleService.selection()?.printer as Printers;
    })
  }

  toggleAllCategories() {
    const allSelected = this.printerFormService.allCategories?.value;
    
    this.printerFormService.categoriesArray?.controls.forEach((control: any) => {
      control.get('checked')?.setValue(allSelected);
    });
  }

  onSingleCategoryChange() {
    const allChecked = this.printerFormService.categoriesArray?.controls.every((ctrl: any) => ctrl.get('checked')?.value);
    
    this.printerFormService.allCategories?.setValue(allChecked, { emitEvent: false });
  }
}